export default __webpack_public_path__ + "static/add@mob-9066329a7fc34c30e2cce9c9cae359e3.svg";